import { PublicClientApplication, Configuration, AuthenticationResult } from '@azure/msal-browser';

const clientId = process.env.VUE_APP_MSAL_CLIENT_ID 
const authority = process.env.VUE_APP_MSAL_AUTHORITY
//dev redirect url
//Read it runtime from 
const redrictUrl = window.location.origin + '/login';
//test redirect url
//const redrictUrl = 'https://test.numberskills.app/login';
//prod redirect url
//const redrictUrl = 'https://numberskills.app/login';

const msalConfig: Configuration = {
  auth: {
    clientId: clientId,
    authority: authority,
    redirectUri: redrictUrl,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

const msalInstance = new PublicClientApplication(msalConfig);
let isInitialized = false;

async function ensureInitialized() {
  if (!isInitialized) {
    await msalInstance.initialize();
    isInitialized = true;
  }
}

export async function signInWithMicrosoft(): Promise<void> {
  try {
    await ensureInitialized();
    await msalInstance.loginRedirect({ scopes: ["User.Read"] });
    // No code after this line will run immediately, as the page will redirect
  } catch (error) {
    console.error('MSAL login error', error);
    throw error;
  }
}
export async function signOutFromMicrosoft(): Promise<void> {
  await ensureInitialized();
  await msalInstance.logoutRedirect({
    onRedirectNavigate: (url) => {
      return false;
    }
  }).then(() => {
  })
}
export async function handleMsalRedirect(): Promise<AuthenticationResult | null> {
  await ensureInitialized();
  try {
    const result = await msalInstance.handleRedirectPromise();
    return result || null;
  } catch (error) {
    console.error('MSAL redirect handling error', error);
    return null;
  }
}

export function getAccessToken(): string | null {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    // You can acquire a token silently for API calls
    // This is a simplified version
    return localStorage.getItem('msal.idtoken');
  }
  return null;
}
